import { TSDTestResponseType } from '@e-origin/shared';

export const SIMULATE_RESPONSE = 'Simulate response for testing purpose';

const tsdSimulatorOptions = {
  accepted: { type: TSDTestResponseType.ACCEPTED, label: 'IETS028 - Accepted' },
  rejected: { type: TSDTestResponseType.REJECTED, label: 'IETS016 - Rejected' },
  activation: { type: TSDTestResponseType.TSD_ACTIVATION, label: 'IETS029 - TSD Activation' },
  pnLinking: { type: TSDTestResponseType.PN_LINKING_RESULT, label: 'IETS030 - PN Linking Result' },
  writeOff: { type: TSDTestResponseType.WRITE_OFF, label: 'IETS045 - Write off' },
  statusUpdate: { type: TSDTestResponseType.STATUS_UPDATE_NOTIFICATION, label: 'IETS095 - Status update' },
  invalidationConfirmation: {
    type: TSDTestResponseType.INVALIDATION_CONFIRMATION,
    label: 'IETS410 - Invalidation confirmation',
  },
  intendedControl: {
    type: TSDTestResponseType.INTENDED_CONTROL_NOTIFICATION,
    label: 'IETS460 - Control Notification',
  },
} as const;

export const getTsdCombinedOptions = () => [
  tsdSimulatorOptions.accepted,
  tsdSimulatorOptions.rejected,
  tsdSimulatorOptions.pnLinking,
  tsdSimulatorOptions.writeOff,
  tsdSimulatorOptions.statusUpdate,
  tsdSimulatorOptions.invalidationConfirmation,
  tsdSimulatorOptions.intendedControl,
];

export const getTsdPrelodgedOptions = () => [
  tsdSimulatorOptions.accepted,
  tsdSimulatorOptions.rejected,
  tsdSimulatorOptions.activation,
  tsdSimulatorOptions.pnLinking,
  tsdSimulatorOptions.writeOff,
  tsdSimulatorOptions.statusUpdate,
  tsdSimulatorOptions.invalidationConfirmation,
  tsdSimulatorOptions.intendedControl,
];

export const getTsdTransferredOptions = () => [
  tsdSimulatorOptions.accepted,
  tsdSimulatorOptions.rejected,
  tsdSimulatorOptions.writeOff,
  tsdSimulatorOptions.statusUpdate,
  tsdSimulatorOptions.intendedControl,
];

export const getTransitDepartureOptions = () => [
  { type: 'CC928C', label: 'CC928C - Functional OK' },
  { type: 'CCF02C', label: 'CCF02C - Pre-lodged accepted (FR)' },
  { type: 'CC028C', label: 'CC028C - Accepted' },
  { type: 'CC004C', label: 'CC004C - Amendment acceptance' },
  { type: 'CC006C', label: 'CC006C - Arrival advice' },
  { type: 'CC009C', label: 'CC009C - Invalidation decision' },
  { type: 'CC019C', label: 'CC019C - Discrepancies' },
  { type: 'CC029C', label: 'CC029C - Release' },
  { type: 'CC035C', label: 'CC035C - Recovery notification ' },
  { type: 'CC045C', label: 'CC045C - Finished' },
  { type: 'CC051C', label: 'CC051C - No release' },
  { type: 'CC055C', label: 'CC055C - Guarantee not valid' },
  { type: 'CC056C', label: 'CC056C - Rejected' },
  { type: 'CC056CCrsErr', label: 'CC056C - Rejected CRS ERR' },
  { type: 'CC060C', label: 'CC060C - In control' },
  { type: 'CC140C', label: 'CC140C - Non-arrival request info' },
  { type: 'CC182C', label: 'CC182C - Forwarded incident information' },
];

export const getTransitArrivalOptions = () => [
  { type: 'CC025C', label: `CC025C - Goods released` },
  { type: 'CC043C', label: `CC043C - Unload permission` },
  { type: 'CC043CWithIncident', label: `CC043C - Unload permission with incident` },
  { type: 'CC043CSubsequent', label: `CC043C - Unload permission subsequent` },
  { type: 'CC043CMultipleContainers', label: `CC043C - Unload permission multiple containers` },
  { type: 'CC057C', label: `CC057C - Rejected` },
  { type: 'CC061C', label: 'CC061C - In control' },
  { type: 'IENCTS043', label: `IENCTS043 - Acceptance` },
];

export const getLowValuesOptions = () => [
  { type: 'CC410A', label: 'CC410A - Invalidation' },
  { type: 'CC426A', label: 'CC426A - Registration' },
  { type: 'CC456A', label: 'CC456A - Rejection' },
  { type: 'CC460A', label: 'CC460A - In control' },
  { type: 'CC451A', label: 'CC451A - No release' },
  { type: 'CC428A', label: 'CC428A - Accepted' },
  { type: 'CC429A', label: 'CC429A - Release' },
  { type: 'XMLCNT', label: 'XMLCNT - Rejection' },
  { type: 'CCTAXA', label: 'CCTAXA - Tax' },
];

export const getHighValuesOptions = () => [
  { type: 'XMLCNT', label: 'XMLCNT - Technical Rejection' },
  { type: 'CCRCVA', label: 'CCRCVA - Received message' },
  { type: 'CCCPIA', label: 'CCCPIA - Coverage pay-up instruction' },
  { type: 'CCEXTA', label: 'CCEXTA - Declaration handled externally' },
  { type: 'CCCPRA', label: 'CCCPRA - Coverage pay-up reminder' },
  { type: 'CCRFIA', label: 'CCRFIA - Enquiry for additional information' },
  { type: 'CCTAXA', label: 'CCTAXA - Tax' },
  { type: 'CC404A', label: 'CC404A - Amendment acceptance' },
  { type: 'CCAMDA', label: 'CCAMDA - Amendments' },
  { type: 'CC426A', label: 'CC426A - Registration' },
  { type: 'CC428A', label: 'CC428A - Accepted' },
  { type: 'CC429A', label: 'CC429A (CLE) - Release' },
  { type: 'CC429AROG', label: 'CC429A (ROG) - Release' },
  { type: 'CC438A', label: 'CC438A - Reminder for providing additional documents' },
  { type: 'CC410A', label: 'CC410A - Invalidation decision' },
  { type: 'CC451A', label: 'CC451A - No release' },
  { type: 'CC456A', label: 'CC456A - Functional rejection' },
  { type: 'CC460A', label: `CC460A - In control` },
];

export const getHighValuesExportOptions = () => [
  { type: 'CC504C', label: 'CC504C - Amendment Accepted' },
  { type: 'CC509C', label: 'CC509C - Invalidation Decision' },
  { type: 'CC528C', label: 'CC528C - Accepted' },
  { type: 'CC560C', label: 'CC560C - In control' },
  { type: 'CC529C', label: 'CC529C - Released (without goods)' },
  { type: 'CC551C', label: 'CC551C - Not Released (without goods)' },
  { type: 'CC599C', label: 'CC599C - Exported (without goods)' },
];

export const getHighValuesImportOptions = () => [
  { type: 'IE460B', label: `IE460B - In control` },
  { type: 'IE428B', label: `IE428B - Accepted` },
  { type: 'IE429B', label: `IE429B - Released` },
  { type: 'IE410B', label: `IE410B - Invalidation decision` },
  { type: 'IE451B', label: `IE451B - Non release notification` },
  { type: 'IE404B', label: `IE404B - Amendment acceptance` },
];

export const formatActionText = (actionText: string): string => actionText.toLowerCase().replace(/\s+/g, '-');
